import moment from "moment"

export default (context) => {
  const M = "admSection."
  return {
    config: {
      hiddenTitle: window.location.href.indexOf('admSuperSection') > -1,
      pageSize: 40,
      list: false,
      remapRow: (form) => {
        form.owner = form.owner.label
        form.superSectionName = form.parentId.label
        return form
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: false,
      export: false,
      search: true,
      import: {
        templateFile: "YearsClassesImport.xlsx"
      }
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          if (r.data.parentId) r.data.parentId = { value: r.data.parentId, label: r.data.parentName }
          if (r.data.owner) r.data.owner = { value: r.data.owner, label: r.data.ownerName }
          if (r.data.entranceTime) r.data.entranceTime = moment().format('YYYY-MM-DD ') + r.data.entranceTime
          if (r.data.leaveTime) r.data.leaveTime = moment().format('YYYY-MM-DD ') + r.data.leaveTime
        }
        return r
      },
      setValuesBeforePost: (v) => {
        if (v.entranceTime) v.entranceTime = moment(v.entranceTime).format('HH:mm')
        if (v.leaveTime) v.leaveTime = moment(v.leaveTime).format('HH:mm')
        if (v.parentId) v.parentId = v.parentId.value
        if (v.owner) v.owner = v.owner.value
        return v
      },
      fields: [
        {
          col: 6,
          name: "name",
          value: "",
          type: "text",
          label: `${M}sectionName`,
          rules: 'required',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "desc",
          value: "",
          type: "text",
          label: "main.desc",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "color",
          value: "",
          type: "text",
          label: "main.color",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "maxMembers",
          value: "",
          type: "number",
          label: `${M}maxMembers`,
          rules: 'required|numeric',
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "externalId",
          value: "",
          type: "text",
          label: "main.externalId",
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "parentId",
          value: "",
          type: "select",
          label: `${M}parentSectionId`,
          rules: 'required',
          opts: {
            style: 'float-label',
            path: () => { return 'admSuperSection/get' },
            setOutput: v => v
          }
        },
        {
          col: 6,
          name: "entranceTime",
          value: "",
          type: "time",
          label: `${M}entranceTime`,
          opts: {
            style: 'float-label',
            timeIntervals: 60
          }
        },
        {
          col: 6,
          name: "leaveTime",
          value: "",
          type: "time",
          label: `${M}leaveTime`,
          opts: {
            style: 'float-label',
            timeIntervals: 60
          }
        },
        {
          col: 6,
          name: "entranceGate",
          value: "",
          type: "text",
          label: `${M}entranceGate`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "leaveGate",
          value: "",
          type: "text",
          label: `${M}leaveGate`,
          opts: {
            style: 'float-label'
          }
        },
        {
          col: 6,
          name: "owner",
          value: "",
          type: "select",
          label: "main.responsible",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: () => { return 'admStaff/get?pick=true' },
            withImg: true,
            searchOnline: true,
            setOutput: v => v
          }
        },
        {
          inactive: true,
          col:6,
          name:"sync",
          value: false,
          type: "switch",
          label: `${M}syncWithExternalSystem`
        },
        /*
        {
          col: 12,
          name: "file1",
          value: "",
          type: "dropzone",
          label: "Firma del tutor",
          opts: {
            path: ()=> "admSection/file",
            accept: '.gif, .jpg, .jpeg, .png'
          }
        },
        */
      ]
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.color",
        accessor: "color"
      },
      {
        Header: "main.responsible",
        accessor: "owner"
      },
      {
        Header: "main.superSection",
        accessor: "superSectionName"
      },
      {
        Header: "main.externalId",
        accessor: "externalId"
      },
    ]
  }
}